<template>
  <div class="contact">
    <h1 class="ui header">お問い合わせ</h1>
    <p>下記お問い合わせフォームからご連絡ください。</p>
    <div class="contact-form">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfz9TFOwhHryobMDwz0tlP20YiSXfBbp4go0dBqI-eNf9AZFA/viewform?embedded=true" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2,h3 {
    font-weight: 900;
    color: black;
  }
  p{
    color: black;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
  .contact{
    margin-top: 110px;
  }
  @media screen and (max-width: 600px) {
    .contact-form{
      margin: 50px 15px;
    }
    .contact-form iframe{
      width:100%;
      height:1300px;
    }
  }
  @media screen and (min-width: 601px) {
    .contact-form{
      margin: 50px;
    }
    .contact-form iframe{
      width:600px;
      height:1100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue